// De vaste vragen die de knoppen op een Doorloopje in de chat zetten.
// Ze bevatten alleen de vraag van de leraar: de pagina gaat al mee via aiContext.
export const chatVraag = (actie, titel) => {
  if (actie === 'Maak lesplan') {
    return [
      `Maak een concreet lesplan gebaseerd op het Doorloopje "${titel}".`,
      `Gebruik de 5 stappen van dit Doorloopje als ruggengraat en maak het direct toepasbaar in de klas.`,
      `Lever op: leerdoelen, benodigd materiaal, tijdsindeling (±45-60 min), differentiatieopties en formatieve check.`,
    ].join(' ');
  }
  if (actie === 'Maak een samenvatting') {
    return [
      `Maak een beknopte samenvatting (max 150 woorden) van het Doorloopje "${titel}".`,
      `Focus op doel, kernstappen en wanneer/waarom je dit inzet.`,
    ].join(' ');
  }
  return null;
};
